import { logger } from 'src/lib/logger'

const resetErrorAndLoading = {
  errorMessage: null,
  loadingMessage: null,
}

const debug = process.env.HOST.includes('localhost')

export const threadReducer = (state, action) => {
  if (debug) {
    logger.dev({ [action.type]: action.payload })
  }
  switch (action.type) {
    case 'SET_THREAD':
      return {
        ...state,
        thread: action.payload,
        ...resetErrorAndLoading,
        pages: [],
      }
    case 'SET_THREADS':
      return { ...state, threads: action.payload }
    case 'ADD_MESSAGE':
      logger.dev('ADD_MESSAGE', { action: action.payload })
      return {
        ...state,
        thread: {
          ...(state.thread || {}),
          messages: [...(state.thread?.messages || []), action.payload],
        },
      }

    case 'SET_CONTEXT_OBJECTS':
      return {
        ...state,
        thread: {
          ...(state.thread || {}),
          ...(action.payload.contextObjects && {
            contextObjects: action.payload.contextObjects,
          }),
          ...(action.payload.dismissedObjects && {
            dismissedObjects: action.payload.dismissedObjects,
          }),
        },
      }
    case 'SET_CONTEXT_STRING':
      return {
        ...state,
        contextString: action.payload,
      }
    case 'SET_CONTEXT_STATUS':
      return {
        ...state,
        contextStatus: action.payload,
      }
    case 'SET_THREAD_ERROR':
      return { ...state, errorMessage: action.payload }
    case 'SET_THREAD_MESSAGES':
      return { ...state, messages: action.payload }
    case 'SET_PENDING_AI_PROMPT':
      return {
        ...state,
        ...resetErrorAndLoading,
        pendingAiPrompt: action.payload,
      }
    case 'SET_LOADING_MESSAGE':
      logger.dev({ SET_LOADING_MESSAGE: action.payload })
      return {
        ...state,
        ...resetErrorAndLoading,
        loadingMessage: action.payload,
      }
    case 'SET_PAGES':
      return { ...state, pages: action.payload }
    case 'SET_TOKEN':
      return { ...state, token: action.payload }
    case 'SET_TOKEN_COUNT':
      return { ...state, tokenCount: action.payload }
    case 'RESET_THREAD':
      return {
        ...state,
        thread: null,
        ...resetErrorAndLoading,
        pages: [],
      }
    case 'SET_THREAD_TITLE':
      return {
        ...state,
        thread: { ...state.thread, title: action.payload },
      }
    default:
      return state
  }
}
